module.exports = __webpack_public_path__ + "img/iconEmail.dce6a7d3.svg";